/**
 * How a physician's answer to a request period stands, on their own
 * screens (owner, 24 October 2026). "Nothing needed this time" is an
 * answer with no requests: it must not look the same as never having
 * opened the period, which is why a submission is recorded even when it
 * is empty.
 *
 * - `not-answered`: no requests, and nothing submitted.
 * - `nothing-needed`: submitted, with no requests in the period.
 * - `with-requests`: at least one request in the period, whether or not
 *   the submission was recorded (requests older than the record still are
 *   an answer).
 *
 * Pure, so it is tested without a browser.
 */
import type { ISODate } from '../dates/iso.ts';

export type AnswerState = 'not-answered' | 'nothing-needed' | 'with-requests';

/** `requests`: how many the physician has in the period; `submittedOn`: the day they last submitted, if ever. */
export function answerState(requests: number, submittedOn: ISODate | null | undefined): AnswerState {
  if (requests > 0) return 'with-requests';
  return submittedOn ? 'nothing-needed' : 'not-answered';
}
